import { c as _c } from "react/compiler-runtime";
import type { OffersByCategory } from '@cc-shopping/contracts/compare/schema/types';
import { CompareQuickFilters } from '../CompareQuickFilters';
import { useCompareContext } from '../Context';
import type { CardOfferButtonWithAnalytics } from '../HorizontalScrollableCardList';
import { createOfferButton } from './utils';
interface Props {
  offersByCategory: OffersByCategory;
}
export const CompareQuickFiltersWrapper = t0 => {
  const $ = _c(9);
  const {
    offersByCategory
  } = t0;
  const {
    allOffers,
    previouslyViewedIds
  } = useCompareContext();
  let t1;
  if ($[0] !== allOffers || $[1] !== offersByCategory || $[2] !== previouslyViewedIds) {
    const categoryToCardOfferButtons = Object.fromEntries(Object.entries(offersByCategory).map(_temp));
    let t2;
    if ($[4] !== allOffers || $[5] !== previouslyViewedIds) {
      let t3;
      if ($[7] !== allOffers) {
        t3 = (id, index_0) => {
          const creditCardOffer_1 = allOffers.find(creditCardOffer_0 => creditCardOffer_0.id === id);
          return creditCardOffer_1 ? createOfferButton(creditCardOffer_1, "previously_viewed", index_0) : null;
        };
        $[7] = allOffers;
        $[8] = t3;
      } else {
        t3 = $[8];
      }
      t2 = previouslyViewedIds.map(t3).filter(Boolean);
      $[4] = allOffers;
      $[5] = previouslyViewedIds;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    const previouslyViewedCardOfferButtons = t2 as CardOfferButtonWithAnalytics[];
    categoryToCardOfferButtons["previously-viewed"] = previouslyViewedCardOfferButtons;
    t1 = <CompareQuickFilters categoryToCardOfferButtons={categoryToCardOfferButtons} />;
    $[0] = allOffers;
    $[1] = offersByCategory;
    $[2] = previouslyViewedIds;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(t0) {
  const [category, creditCardOffers] = t0;
  const cardOfferButtons = creditCardOffers.offers.map((creditCardOffer, index) => createOfferButton(creditCardOffer, creditCardOffers.section, index));
  return [category, cardOfferButtons];
}